module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('vue-progress-bar'), _vm._v(" "), (_vm.screenSize.mobile) ? _c('div', {
    staticClass: "top-block"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      "hidden": _vm.logoHidden
    },
    attrs: {
      "id": "pop-up"
    },
    on: {
      "click": _vm.toggleLogo
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/logo.png")
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('dsSideBar', {
    attrs: {
      "screen-size": _vm.screenSize,
      "posts": _vm.posts,
      "overons": _vm.overonsPost,
      "loaded": _vm.loaded,
      "location": _vm.location,
      "language": _vm.language
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('dsHeader', {
    attrs: {
      "screen-size": _vm.screenSize,
      "quotes": _vm.quotes,
      "loaded": _vm.loaded,
      "language": _vm.language
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('main', {
    staticClass: "full-width float-left margin-right",
    attrs: {
      "id": "main"
    }
  }, [_c('div', {
    staticClass: "main-column"
  }, [(_vm.location.overons && _vm.loaded.overons) ? _c('div', {
    staticClass: "single-content float-left one-column-fixed-height border-bottom padding-bottom padding-top"
  }, [(_vm.language === "nl" && _vm.loaded.posts) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.overonsPost.acf.header)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && _vm.loaded.posts) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.overonsPost.acf.header_en)
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.language === "nl" && _vm.location.overons && _vm.loaded.overons) ? _c('div', {
    staticClass: "single-content main-column padding-top",
    domProps: {
      "innerHTML": _vm._s(_vm.overonsPost.content.rendered)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && _vm.location.overons && _vm.loaded.overons) ? _c('div', {
    staticClass: "single-content main-column padding-top",
    domProps: {
      "innerHTML": _vm._s(_vm.overonsPost.acf.main_text_en)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.location.overons && _vm.loaded.overons) ? _c('aside', {
    staticClass: "secondary-column float-left"
  }, [_c('div', {
    staticClass: "team-container border-bottom margin-bottom"
  }, [(_vm.language === "nl") ? _c('div', {
    staticClass: "padding-top margin-bottom center"
  }, [_c('span', {
    staticClass: "border-bottom strong"
  }, [_vm._v("Wie zijn wij?")])]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('div', {
    staticClass: "padding-top margin-bottom center"
  }, [_c('span', {
    staticClass: "border-bottom strong"
  }, [_vm._v("Who are we?")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.overonsPost.acf["wie_zijn_wij"]), function(item) {
    return _c('dsTeamItem', {
      attrs: {
        "item": item,
        "language": _vm.language
      }
    })
  })], 2), _vm._v(" "), (_vm.language === "nl") ? _c('div', {
    staticClass: "center margin-bottom"
  }, [_c('span', {
    staticClass: "border-bottom strong"
  }, [_vm._v("Pers")])]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('div', {
    staticClass: "center margin-bottom"
  }, [_c('span', {
    staticClass: "border-bottom strong"
  }, [_vm._v("Press")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.overonsPost.acf.press), function(item) {
    return _c('a', {
      key: item.link,
      staticClass: "press secondary-color strong margin-bottom",
      attrs: {
        "href": item.link,
        "target": "_blank"
      },
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.location.single && _vm.loaded.posts) ? _c('div', {
    staticClass: "single-content main-column padding-top"
  }, [(_vm.specialCategory) ? _c('div', [_c('router-link', {
    staticClass: "strong no-underline",
    attrs: {
      "to": {
        name: _vm.specialCategory.slug,
        params: {
          language: _vm.language
        }
      }
    }
  }, [(_vm.language === "nl") ? _c('span', [_vm._v("< " + _vm._s(_vm.specialCategory.name))]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('span', [_vm._v("< " + _vm._s(_vm.specialCategory.name))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.language === "nl") ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.posts.single.acf.main_text)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.posts.single.acf.main_text_en)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.screenSize.mobile === false) ? _c('p', {
    staticClass: "secondary-color large-text uppercase margin-bottom light",
    attrs: {
      "id": "tags"
    }
  }, [_c('span', {
    staticClass: "italic"
  }, [_vm._v("TAGS")]), _vm._v(" "), _vm._l((_vm.posts.single.tags), function(tag) {
    return _c('dsTagItemInline', {
      attrs: {
        "tag": tag,
        "tags": _vm.tagCollection,
        "language": _vm.language
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.language === "nl") ? _c('p', {
    staticClass: "large-text secondary-color light"
  }, [_c('span', {
    staticClass: "high-light"
  }, [_vm._v("DELEN")]), _vm._v(" "), _c('span', [_vm._v("op\n              "), _c('a', {
    staticClass: "share-to-fb",
    attrs: {
      "href": ""
    }
  }, [_vm._v("Facebook")])])]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('p', {
    staticClass: "large-text secondary-color light"
  }, [_c('span', {
    staticClass: "high-light"
  }, [_vm._v("SHARE")]), _vm._v(" "), _c('span', [_vm._v("on\n              "), _c('a', {
    staticClass: "share-to-fb",
    attrs: {
      "href": ""
    }
  }, [_vm._v("Facebook")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.location.single && _vm.loaded.posts) ? _c('aside', {
    staticClass: "secondary-column float-left"
  }, [(_vm.loaded.tags) ? _c('dsTags', {
    staticClass: "aside-tags border-bottom margin-bottom",
    attrs: {
      "tags": "tagCollection",
      "language": _vm.language,
      "tags": _vm.tags
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "nl") ? _c('div', {
    staticClass: "center margin-bottom"
  }, [_c('span', {
    staticClass: "border-bottom strong"
  }, [_vm._v("Lees ook")])]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('div', {
    staticClass: "center margin-bottom"
  }, [_c('span', {
    staticClass: "border-bottom strong"
  }, [_vm._v("Related posts")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.relatedPosts), function(item) {
    return _c('dsGridItem', {
      attrs: {
        "item": item,
        "language": _vm.language,
        "tags": _vm.tagCollection,
        "location": _vm.location,
        "screen-size": _vm.screenSize
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.location.verdieping && _vm.loaded.posts && _vm.loaded.pages) ? _c('dsSectionIntro', {
    attrs: {
      "language": _vm.language,
      "loaded": _vm.loaded,
      "location": _vm.location,
      "screen-size": _vm.screenSize,
      "introNL": _vm.intro.verdieping.content.rendered,
      "introEN": _vm.intro.verdieping.acf.main_text_en,
      "tags": _vm.tags
    }
  }) : _vm._e(), _vm._v(" "), (_vm.location.verdieping && _vm.loaded.posts && _vm.loaded.pages) ? _c('dsGrid', {
    attrs: {
      "tags": _vm.tagCollection,
      "location": _vm.location,
      "screen-size": _vm.screenSize,
      "posts": _vm.posts.verdieping,
      "language": _vm.language
    }
  }) : _vm._e(), _vm._v(" "), (_vm.location.home && _vm.loaded.posts && _vm.loaded.tags) ? _c('dsFeatured', {
    attrs: {
      "posts": _vm.posts,
      "screen-size": _vm.screenSize,
      "tags": _vm.tagCollection,
      "language": _vm.language
    }
  }) : _vm._e(), _vm._v(" "), (_vm.location.home && _vm.loaded.posts && _vm.loaded.tags) ? _c('dsGrid', {
    attrs: {
      "screen-size": _vm.screenSize,
      "posts": _vm.posts.first,
      "location": _vm.location,
      "tags": _vm.tagCollection,
      "language": _vm.language
    }
  }) : _vm._e(), _vm._v(" "), (_vm.location.meedoen && _vm.loaded.meedoen) ? _c('div', {
    staticClass: "single-content main-column float-left one-column-fixed-height border-bottom padding-bottom padding-top"
  }, [(_vm.language === "nl" && _vm.loaded.posts) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.meedoenPost.acf.header)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && _vm.loaded.posts) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.meedoenPost.acf.header_en)
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.location.meedoen && _vm.loaded.meedoen) ? _c('aside', {
    staticClass: "secondary-column float-left"
  }, [(_vm.loaded.tags) ? _c('dsTags', {
    staticClass: "aside-tags border-bottom margin-bottom",
    attrs: {
      "language": _vm.language,
      "tags": _vm.tags
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.location.nieuws && _vm.loaded.pages) ? _c('dsSectionIntro', {
    attrs: {
      "language": _vm.language,
      "loaded": _vm.loaded,
      "location": _vm.location,
      "screen-size": _vm.screenSize,
      "introNL": _vm.intro.nieuws.content.rendered,
      "introEN": _vm.intro.nieuws.acf.main_text_en,
      "tags": _vm.tags
    }
  }) : _vm._e(), _vm._v(" "), (_vm.location.nieuws && _vm.loaded.posts && _vm.loaded.tags) ? _c('dsGrid', {
    attrs: {
      "screen-size": _vm.screenSize,
      "posts": _vm.posts.nieuws,
      "tags": _vm.tagCollection,
      "location": _vm.location,
      "language": _vm.language
    }
  }) : _vm._e(), _vm._v(" "), (_vm.location.programma && _vm.loaded.pages) ? _c('dsSectionIntro', {
    attrs: {
      "language": _vm.language,
      "loaded": _vm.loaded,
      "location": _vm.location,
      "screen-size": _vm.screenSize,
      "filters": _vm.filters,
      "introNL": _vm.intro.programma.content.rendered,
      "introEN": _vm.intro.programma.acf.main_text_en,
      "tags": _vm.tags
    }
  }) : _vm._e(), _vm._v(" "), (_vm.location.programma && _vm.loaded.posts && _vm.loaded.tags) ? _c('dsGrid', {
    attrs: {
      "screen-size": _vm.screenSize,
      "posts": _vm.posts.programma,
      "filters": _vm.filters,
      "location": _vm.location,
      "tags": _vm.tagCollection,
      "language": _vm.language
    }
  }) : _vm._e(), _vm._v(" "), (_vm.location.zoek && _vm.loaded.search) ? _c('dsGrid', {
    attrs: {
      "screen-size": _vm.screenSize,
      "posts": _vm.posts.search,
      "location": _vm.location,
      "search": _vm.currentSearchTerm,
      "tags": _vm.tagCollection,
      "language": _vm.language
    }
  }) : _vm._e(), _vm._v(" "), (_vm.location.tag && _vm.loaded.tagSearch) ? _c('dsGrid', {
    attrs: {
      "screen-size": _vm.screenSize,
      "posts": _vm.posts.tag,
      "location": _vm.location,
      "tag": _vm.currentTag,
      "tags": _vm.tagCollection,
      "language": _vm.language
    }
  }) : _vm._e(), _vm._v(" "), (_vm.location["verdieping-archief"] && _vm.loaded.pages) ? _c('dsSectionIntro', {
    attrs: {
      "language": _vm.language,
      "loaded": _vm.loaded,
      "location": _vm.location,
      "screen-size": _vm.screenSize,
      "introNL": _vm.intro.verdiepingArchief.content.rendered,
      "introEN": _vm.intro.verdiepingArchief.acf.main_text_en,
      "tags": _vm.tags
    }
  }) : _vm._e(), _vm._v(" "), (_vm.location["verdieping-archief"] && _vm.loaded.posts && _vm.loaded.tags) ? _c('dsGrid', {
    attrs: {
      "screen-size": _vm.screenSize,
      "posts": _vm.posts.archief,
      "location": _vm.location,
      "tags": _vm.tagCollection,
      "language": _vm.language
    }
  }) : _vm._e(), _vm._v(" "), (_vm.location["verdieping-programma"] && _vm.loaded.pages) ? _c('dsSectionIntro', {
    attrs: {
      "language": _vm.language,
      "loaded": _vm.loaded,
      "location": _vm.location,
      "screen-size": _vm.screenSize,
      "introNL": _vm.intro.verdiepingProgramma.content.rendered,
      "introEN": _vm.intro.verdiepingProgramma.acf.main_text_en,
      "tags": _vm.tags
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "nl" && _vm.location["verdieping-programma"] && _vm.loaded.pages) ? _c('div', {
    staticClass: "single-content main-column padding-top",
    domProps: {
      "innerHTML": _vm._s(_vm.intro.verdiepingProgramma.acf.full_text)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && _vm.location["verdieping-programma"] && _vm.loaded.pages) ? _c('div', {
    staticClass: "single-content main-column padding-top",
    domProps: {
      "innerHTML": _vm._s(_vm.intro.verdiepingProgramma.acf.full_text_en)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.location["verdieping-essays"] && _vm.loaded.pages) ? _c('dsSectionIntro', {
    attrs: {
      "language": _vm.language,
      "loaded": _vm.loaded,
      "location": _vm.location,
      "screen-size": _vm.screenSize,
      "introNL": _vm.intro.verdiepingEssays.content.rendered,
      "introEN": _vm.intro.verdiepingEssays.acf.main_text_en,
      "tags": _vm.tags
    }
  }) : _vm._e(), _vm._v(" "), (_vm.location["verdieping-essays"] && _vm.loaded.posts && _vm.loaded.tags) ? _c('dsGrid', {
    attrs: {
      "screen-size": _vm.screenSize,
      "posts": _vm.posts.essays,
      "location": _vm.location,
      "tags": _vm.tagCollection,
      "language": _vm.language
    }
  }) : _vm._e(), _vm._v(" "), (_vm.location["verdieping-mapping"]) ? _c('dsSectionIntro', {
    attrs: {
      "language": _vm.language,
      "loaded": _vm.loaded,
      "location": _vm.location,
      "screen-size": _vm.screenSize,
      "introNL": _vm.intro.verdiepingMapping.content.rendered,
      "introEN": _vm.intro.verdiepingMapping.acf.main_text_en,
      "tags": _vm.tags
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "nl" && _vm.location["verdieping-mapping"] && _vm.loaded.pages) ? _c('div', {
    staticClass: "single-content main-column padding-top",
    domProps: {
      "innerHTML": _vm._s(_vm.intro.verdiepingMapping.acf.full_text)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && _vm.location["verdieping-mapping"] && _vm.loaded.pages) ? _c('div', {
    staticClass: "single-content main-column padding-top",
    domProps: {
      "innerHTML": _vm._s(_vm.intro.verdiepingMapping.acf.full_text_en)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.location["verdieping-links-naar-meer"] && _vm.loaded.pages) ? _c('dsSectionIntro', {
    attrs: {
      "language": _vm.language,
      "loaded": _vm.loaded,
      "location": _vm.location,
      "screen-size": _vm.screenSize,
      "introNL": _vm.intro.verdiepingLinksNaarMeer.content.rendered,
      "introEN": _vm.intro.verdiepingLinksNaarMeer.acf.main_text_en,
      "tags": _vm.tags
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "nl" && _vm.location["verdieping-links-naar-meer"] && _vm.loaded.pages) ? _c('div', {
    staticClass: "single-content main-column padding-top",
    domProps: {
      "innerHTML": _vm._s(_vm.intro.verdiepingLinksNaarMeer.acf.full_text)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && _vm.location["verdieping-links-naar-meer"] && _vm.loaded.pages) ? _c('div', {
    staticClass: "single-content main-column padding-top",
    domProps: {
      "innerHTML": _vm._s(_vm.intro.verdiepingLinksNaarMeer.acf.full_text_en)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.location["verdieping-klankbordgroep"] && _vm.loaded.pages) ? _c('dsSectionIntro', {
    attrs: {
      "language": _vm.language,
      "loaded": _vm.loaded,
      "location": _vm.location,
      "screen-size": _vm.screenSize,
      "introNL": _vm.intro.verdiepingKlankbordgroep.content.rendered,
      "introEN": _vm.intro.verdiepingKlankbordgroep.acf.main_text_en,
      "tags": _vm.tags
    }
  }) : _vm._e(), _vm._v(" "), (_vm.location["verdieping-klankbordgroep"] && _vm.loaded.posts && _vm.loaded.tags) ? _c('dsGrid', {
    attrs: {
      "screen-size": _vm.screenSize,
      "posts": _vm.posts.klankbordgroep,
      "location": _vm.location,
      "tags": _vm.tagCollection,
      "language": _vm.language
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.loaded.posts) ? _c('dsFooter', {
    attrs: {
      "screen-size": _vm.screenSize,
      "location": _vm.location,
      "language": _vm.language
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fcdab7dc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 228
// module chunks = 2